import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
import reportWebVitals from './reportWebVitals';
import { WidgetProvider } from './contexts/WidgetContext';
import { ProgressProvider } from './contexts/ProgressContext';
import { MsalProvider } from '@azure/msal-react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { msalInstance } from './config/authConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <MsalProvider instance={msalInstance}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <ProgressProvider>
          <WidgetProvider>
            <App />
          </WidgetProvider>
        </ProgressProvider>
      </GoogleOAuthProvider>
    </MsalProvider>
  </>
);

reportWebVitals();
